import React from "react";

const heroImage = "/Images/ContactHero.png";

const Contact = () => {
  return (
    <>
      {/* HERO */}

      <section
        className="position-relative"
        style={{
          height: "520px",
          backgroundImage: `url(${heroImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center"
        }}
      >
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{
            background:
              "linear-gradient(rgba(0,0,0,.2), rgba(0,0,0,.55))"
          }}
        />

        <div className="container h-100 position-relative">
          <div className="row h-100 align-items-end">

            <div className="col-lg-5 text-white pb-5">

              <small
                className="text-uppercase"
                style={{
                  letterSpacing: "2px",
                  fontSize: "10px"
                }}
              >
                Get In Touch
              </small>

              <h1
                className="mt-3"
                style={{
                  fontFamily: "Georgia, serif",
                  fontSize: "52px",
                  lineHeight: "1.1"
                }}
              >
                I actually
                read your emails.
              </h1>

              {/* <p
                className="mt-4"
                style={{
                  maxWidth: "430px",
                  lineHeight: "1.8",
                  fontSize: "14px"
                }}
              >
                Whether you want to volunteer, report a
                nesting site, support our work, or just tell
                us you've been following the hornbills for
                years — reach out.
              </p> */}

            </div>

          </div>
        </div>
      </section>

      {/* QUOTE STRIP */}

      {/* <section
        className="py-5 text-center text-white"
        style={{
          background: "#6d735d"
        }}
      >
        <div
          className="container"
          style={{
            maxWidth: "800px"
          }}
        >
          <div
            style={{
              fontSize: "40px",
              opacity: ".4"
            }}
          >
            "
          </div>

          <p
            className="fst-italic"
            style={{
              fontFamily: "Georgia, serif",
              fontSize: "20px",
              lineHeight: "1.8"
            }}
          >
            The emails that move us most aren't from
            donors — they're from kids in Johannesburg
            asking why the hornbill sounds like thunder.
          </p>

          <small
            className="text-uppercase"
            style={{
              letterSpacing: "3px"
            }}
          >
            Dave Reynolds Field Director
          </small>
        </div>
      </section> */}

      {/* FORM SECTION */}

      <section
        className="py-5"
        style={{
          background: "#f5f3ee"
        }}
      >
        <div className="container">

          <div className="row g-5">

            {/* LEFT */}

            <div className="col-lg-8">

              <small
                className="text-uppercase"
                style={{
                  letterSpacing: "2px",
                  color: "#999"
                }}
              >
                Drop Us A Line
              </small>

              <h2
                className="mb-5"
                style={{
                  fontFamily: "Georgia, serif",
                  fontSize: "48px"
                }}
              >
                Say hello. Ask something.
                <br />
                Tell me what you saw once.
              </h2>

              <form>

                <div className="row mb-4">

                  <div className="col-md-6">
                    <label className="small text-muted">
                      FIRST NAME *
                    </label>

                    <input
                      className="form-control border-0 border-bottom rounded-0 bg-transparent"
                      placeholder="eg Matt"
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="small text-muted">
                      LAST NAME
                    </label>

                    <input
                      className="form-control border-0 border-bottom rounded-0 bg-transparent"
                      placeholder="eg Neal"
                    />
                  </div>

                </div>

                <div className="mb-4">
                  <label className="small text-muted">
                    EMAIL ADDRESS *
                  </label>

                  <input
                    className="form-control border-0 border-bottom rounded-0 bg-transparent"
                    placeholder="hello@example.com"
                  />
                </div>

                <div className="mb-4">
                  <label className="small text-muted">
                    ORGANISATION
                  </label>

                  <input
                    className="form-control border-0 border-bottom rounded-0 bg-transparent"
                  />
                </div>

                <div className="mb-4">
                  <label className="small text-muted">
                    REASON FOR GETTING IN TOUCH
                  </label>

                  <select
                    className="form-select border-0 border-bottom rounded-0 bg-transparent"
                  >
                    <option>Select the best fit...</option>
                  </select>
                </div>

                <div className="mb-4">
                  <label className="small text-muted">
                    SUBJECT
                  </label>

                  <input
                    className="form-control border-0 border-bottom rounded-0 bg-transparent"
                  />
                </div>

                <div className="mb-4">
                  <label className="small text-muted">
                    YOUR MESSAGE *
                  </label>

                  <textarea
                    rows="6"
                    className="form-control rounded-0"
                    placeholder="Write as much or as little as you need."
                  />
                </div>

                <button
                  className="btn text-white rounded-0 px-5 py-3"
                  style={{
                    background: "#9b5d08"
                  }}
                >
                  SEND MESSAGE →
                </button>

              </form>

            </div>

            {/* RIGHT */}

            <div className="col-lg-4">

              <div className="bg-white p-4 mb-4">
                <small>
                  🟢 We respond to most messages
                  within 3–5 working days.
                </small>
              </div>

              {/* <div className="bg-white p-4 mb-4">
                <p
                  className="fst-italic mb-0"
                  style={{
                    fontFamily: "Georgia, serif"
                  }}
                >
                  Every few months someone writes
                  to say they saw a hornbill and
                  thought of us.
                </p>
              </div> */}

              <div
                className="p-4 text-white mb-4"
                style={{
                  background: "#6d735d"
                }}
              >
                <p
                  className="fst-italic mb-0"
                  style={{
                    fontFamily: "Georgia, serif"
                  }}
                >
                  We love big questions. We've
                  never met a bird or a person
                  worth reducing to a FAQ.
                </p>
              </div>

              {/* <div className="bg-white p-4 mb-4">
                <p
                  className="fst-italic mb-0"
                  style={{
                    fontFamily: "Georgia, serif"
                  }}
                >
                  The most useful partnership
                  we've ever had started with
                  someone asking a simple
                  question.
                </p>
              </div> */}

              {/* <div className="mt-5">

                <small
                  className="text-uppercase d-block mb-3"
                  style={{
                    letterSpacing: "2px"
                  }}
                >
                  Common Questions
                </small>

                <div className="border-bottom py-2">
                  Can I volunteer in the field?
                </div>

                <div className="border-bottom py-2">
                  I'm a journalist. Who do I contact?
                </div>

                <div className="border-bottom py-2">
                  Can my school get involved?
                </div>

                <div className="border-bottom py-2">
                  I witnessed a bird in distress.
                </div>

              </div> */}

            </div>

          </div>

        </div>
      </section>

      {/* FOOTER INFO */}

      <section
        className="py-5"
        style={{
          background: "#efede8"
        }}
      >
        <div className="container">

          <div className="row">

            <div className="col-md-4">
              <small className="text-uppercase text-muted">
                Primary Email
              </small>

              <p className="mt-2">
                info@savehornbills.com 
              </p>
            </div>

            <div className="col-md-4">
              <small className="text-uppercase text-muted">
                Follow The Work
              </small>

              <p className="mt-2">@savehornbills</p>
            </div>

            <div className="col-md-4">
              <small className="text-uppercase text-muted">
                Donate Securely
              </small>

              <p className="mt-2">
                Wildlife Conservation Fund
              </p>
            </div>

          </div>

        </div>
      </section>


      <section
        className="text-center text-white py-5"
        style={{
          background: "#6b735d",
          minHeight: "520px",
          display: "flex",
          alignItems: "center"
        }}
      >
        <div
          className="container"
          style={{
            maxWidth: "900px"
          }}
        >
          <div
            style={{
              fontSize: "32px",
              opacity: ".25",
              marginBottom: "30px"
            }}
          >
            "
          </div>

          <h3
            className="fw-normal fst-italic mx-auto"
            style={{
              fontFamily: "Georgia, serif",
              fontSize: "34px",
              lineHeight: "1.9",
              maxWidth: "760px"
            }}
          >
            Somewhere in South Africa right now,
            a Southern Ground Hornbill is walking
            slowly through tall grass, calling once —
            and waiting.
            <br />
          </h3>

          <div
            className="text-uppercase mt-5"
            style={{
              letterSpacing: "3px",
              fontSize: "10px",
              opacity: ".75"
            }}
          >
            Save Hornbills • Founded By A Conservationist,
            Powered By Communities
          </div>

          <div className="mt-5">

            <button
              className="btn text-white rounded-0 px-5 py-3 me-3"
              style={{
                background: "#a15f07",
                fontSize: "11px",
                letterSpacing: "2px",
                fontWeight: 600
              }}
            >
              SUPPORT THE WORK
            </button>

            <button
              className="btn btn-outline-light rounded-0 px-5 py-3"
              style={{
                fontSize: "11px",
                letterSpacing: "2px",
                fontWeight: 600
              }}
            >
              HOW I WORK
            </button>

          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;